var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11H8.5C8.74546 11 8.94961 11.1769 8.99194 11.4101L9 11.5V16.5C9 16.7761 8.77614 17 8.5 17C8.25454 17 8.05039 16.8231 8.00806 16.5899L8 16.5V12.706L2.85355 17.8536C2.65829 18.0488 2.34171 18.0488 2.14645 17.8536C1.97288 17.68 1.9536 17.4106 2.08859 17.2157L2.14645 17.1464L7.292 12H3.5C3.25454 12 3.05039 11.8231 3.00806 11.5899L3 11.5C3 11.2545 3.17688 11.0504 3.41012 11.0081L3.5 11H8.5H3.5ZM17.8536 2.14645C18.0271 2.32001 18.0464 2.58944 17.9114 2.78431L17.8536 2.85355L12.706 8H16.5C16.7455 8 16.9496 8.17688 16.9919 8.41012L17 8.5C17 8.74546 16.8231 8.94961 16.5899 8.99194L16.5 9L11.4796 8.99959L11.4112 8.99213L11.309 8.96221L11.233 8.92281L11.1779 8.88242L11.1464 8.85355L11.109 8.81166L11.0667 8.74977L11.0376 8.69059L11.0166 8.62814L11.0111 8.60499C11.0038 8.5713 11 8.5361 11 8.5L11.0055 8.57392L11.0018 8.5428L11 3.5C11 3.22386 11.2239 3 11.5 3C11.7455 3 11.9496 3.17687 11.9919 3.41012L12 3.5V7.292L17.1464 2.14645C17.3417 1.95118 17.6583 1.95118 17.8536 2.14645Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.fd9298c0749be67dc2f6e9707b30bee3.svg";
export { ForwardRef as ReactComponent };